// extracted by mini-css-extract-plugin
export default {"wrap":"YG-z","articleImagesWrap":"ZG-z","articleImage":"_G-z","singleImage":"aH-z"};